Ext.define('SA.view.menu.EditCombinationLocation', {
    alias: 'widget.menu-edit-combination-location',
    extend: 'Ext.menu.Item',

    bubbleEvents: ['edit:comboLocation'],
    text: 'Edit Combination Location',

    beforeMenuShow() {
        this.refresh();
    },

    getLocation() {
        return this.location;
    },

    handler() {
        var location = this.getLocation(),
            combo = SA.data.CustomLocations.get(location);

        Ext.widget({
            xtype: 'edit-combination-location',
            combo,

            callback: combo => {
                this.fireEvent('edit:comboLocation', combo);
            }
        });
    },

    refresh() {
        var locationId = this.getLocation(),
            location = SA.data.LocationsCache.normalizeLocation(locationId),
            visible = location.type === 'combination';

        this.setVisible(visible);
    }
});